var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSleep({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#A048F2",
    fillOpacity: 0.14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.2442 21.9805C27.8607 23.1717 27.6659 24.4157 27.6669 25.6671C27.6669 32.2945 33.0396 37.6671 39.6669 37.6671C41.3027 37.6699 42.9215 37.3363 44.4229 36.6871C42.8676 41.5118 38.3416 45.0005 33.0002 45.0005C26.3729 45.0005 21.0002 39.6278 21.0002 33.0005C21.0002 28.0625 23.9822 23.8218 28.2442 21.9805Z",
    stroke: "#A048F2",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1063 23.667H44.3329L37.6663 29.0003H44.3329",
    stroke: "#A048F2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleep);
export default __webpack_public_path__ + "static/media/sleep.822d5ef670ae3d7368af3545ac8d4cba.svg";
export { ForwardRef as ReactComponent };